import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";

const TONES = {
  brand: "bg-gradient-to-r from-fuchsia-600 to-indigo-600 text-white",
  info: "bg-sky-600 text-white",
  success: "bg-emerald-600 text-white",
  warning: "bg-amber-500 text-slate-900",
};

// Site-wide announcement bar. Dismissible per visitor (per banner revision).
export default function SiteBanner() {
  const [b, setB] = useState(null);
  useEffect(() => { api.get("/site-banner").then((r) => { if (r.data?.active && r.data.message) setB(r.data); }).catch(() => {}); }, []);
  if (!b) return null;
  if (localStorage.getItem(`site_banner_dismissed_${b.id}`) === "1") return null;
  const dismiss = () => { localStorage.setItem(`site_banner_dismissed_${b.id}`, "1"); setB(null); };
  return (
    <div data-testid="site-banner" className={`flex items-center justify-center gap-3 px-4 py-2 text-sm font-semibold ${TONES[b.tone] || TONES.brand}`}>
      <span className="text-center">{b.message}</span>
      {b.cta_label && b.cta_url && <a href={b.cta_url} data-testid="site-banner-cta" className="shrink-0 rounded-full bg-white/20 px-3 py-0.5 text-xs font-bold underline-offset-2 hover:bg-white/30">{b.cta_label}</a>}
      <button onClick={dismiss} data-testid="site-banner-dismiss" className="absolute right-3 rounded-full p-1 hover:bg-black/10" aria-label="Dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
